import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import SubTitle from "../../../components/SubTitle";
import {useCreateMutation} from "../../../hooks/useQueryHooks";
import {ResponseItem} from "../../../models/clientModels/interfaces/Response";

import {useQueryClient} from "react-query";
import {useNavigate} from "react-router-dom";
import {
  EDCurriculum,
  initializeCurriculum,
} from "../../../models/serverModels/education/EDCurriculum";

import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../../Recoil/Atom/snackBarState";
import * as curriculumListApi from "../../../api/educationApi/curriculumListApi";
import ConfirmButtonGroup from "../../../components/ConfirmButtonGroup";
import * as Params from "../../../models/clientModels/interfaces/apiParams";
import CurriculumForm from "./CurriculumForm";
import {yupResolver} from "@hookform/resolvers/yup";
import {curriculumSchema} from "../../../validation/curriculumSchema";

const CreateCurriculum = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<EDCurriculum>,
    Params.Create<EDCurriculum>
  >({
    api: curriculumListApi.create,
    options: {
      onSuccess: (createData: ResponseItem<EDCurriculum>) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        createData.message.split(":")[0] === "Ok!"
          ? (setSnackBarToggle(true),
            setSnackBarState("create"),
            navigate("/Education/CurriculumList"),
            queryClient.invalidateQueries("CurriculumList"))
          : createData.message.split(":")[0] === "failed"
          ? (setSnackBarToggle(true), setSnackBarState("failed"))
          : null;
      },
    },
  });

  const methods = useForm<EDCurriculum>({
    defaultValues: initializeCurriculum,
    resolver: yupResolver(curriculumSchema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset();
  }, [reset]);

  const onSubmit: SubmitHandler<EDCurriculum> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeCurriculum, ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="교육과정 추가" />
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <CurriculumForm />
        <ConfirmButtonGroup link="/Education/CurriculumList" cancelText="취소" confirmText="저장" />
      </form>
    </FormProvider>
  );
};

export default CreateCurriculum;
